module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/pre-0",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/pre-2",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47437bf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pre1.vue
// module id = 24
// module chunks = 0